import { FORM_ITEM_DATE_PICKER } from "../../../components/Form/FormItems/FormItemDatePicker";
import { FORM_ITEM_NUMBER } from "../../../components/Form/FormItems/FormItemNumber";
import { FORM_ITEM_RESOURCE_SELECT_LAZY_LOADING } from "../../../components/Form/FormItems/FormItemResourceSelectLazyLoading";
import { validityOptions } from "./config";

/**
 * Builds the validity configuration and linked-training field descriptors.
 * Covers: Validity type selector, day/year number inputs (conditional),
 * specific date picker, notification period, linked training, and
 * linked training notification days.
 */
export const buildValidityFields = ({
  data,
  isNewRecord,
  validity,
  setValidity,
  linkedTraining,
  setLinkedTraining
}) => [
  {
    required: true,
    type: FORM_ITEM_RESOURCE_SELECT_LAZY_LOADING,
    name: "validity",
    label: "trg.new_training.validity",
    placeholder: "trg.new_training.validity",
    fieldProps: {
      staticOptions: validityOptions,
      onChange: (value) => setValidity(value)
    }
  },
  {
    required: true,
    type: FORM_ITEM_NUMBER,
    name: "day_number",
    label: "trg.new_training.number_of_days",
    placeholder: "trg.new_training.number_of_days",
    visible: validity === "day_number"
  },
  validity === "year_number" || validity === "december_in_x_years" || validity === "end_month_in_x_years"
    ? {
        required: true,
        type: FORM_ITEM_NUMBER,
        name: "year_number",
        label: "trg.new_training.number_of_years",
        placeholder: "trg.new_training.number_of_years",
        visible: validity === "year_number" || validity === "december_in_x_years" || validity === "end_month_in_x_years"
      }
    : {
        required: true,
        type: FORM_ITEM_NUMBER,
        name: "years_minus_one_day",
        label: "trg.new_training.number_of_years",
        placeholder: "trg.new_training.number_of_years",
        visible: validity === "years_minus_one_day"
      },
  {
    type: FORM_ITEM_DATE_PICKER,
    required: true,
    name: "specific_date",
    label: "trg.new_training.specific_date",
    placeholder: "trg.new_training.specific_date",
    visible: validity === "specific_date"
  },
  {
    required: true,
    type: FORM_ITEM_NUMBER,
    name: "notification_period",
    label: "trg.new_training.notification_period",
    placeholder: "trg.new_training.notification_period",
    visible: validity && validity !== "no_expiry",
    fieldProps: {
      disabled: !!data.shared_by_company_name
    }
  },
  {
    type: FORM_ITEM_RESOURCE_SELECT_LAZY_LOADING,
    name: "linked_training_id",
    label: "trg.new_training.link_this_training_to",
    placeholder: "trg.new_training.link_this_training_to",
    apiRoute:
      "trg/trainings?field%5B%5D=active&op%5B%5D=eq&order_by_column%5B%5D=name&order_by_type%5B%5D=asc&term%5B%5D=1",
    fieldProps: {
      searchColumns: ["name", "code"],
      requestOnMount: !isNewRecord,
      onChange: (value) => setLinkedTraining(value),
      disabled: !!data.shared_by_company_name,
      transformer: (options) =>
        options.map((option) => ({
          ...option,
          text: `${option.name} (${option.code})`
        }))
    }
  },
  {
    required: true,
    type: FORM_ITEM_NUMBER,
    name: "linked_training_notification",
    label: "trg.new_training.number_of_days_for_linked_training",
    placeholder: "trg.new_training.number_of_days_for_linked_training",
    visible: !!linkedTraining,
    fieldProps: {
      disabled: !!data.shared_by_company_name
    }
  }
];
